import React from "react";
import { MapPin } from "lucide-react";
import { AREAS, WHATSAPP_URL, BUSINESS } from "../lib/business";

export default function AreasAtendidas() {
  return (
    <section id="areas" data-testid="areas-section" className="bg-[#0A0A0A] py-16 md:py-24">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="grid lg:grid-cols-5 gap-10 items-start">
          <div className="lg:col-span-2">
            <div className="inline-block bg-[#E50914] px-3 py-1 mb-4">
              <span className="font-anton text-sm uppercase tracking-widest text-white">Cobertura Regional</span>
            </div>
            <h2 className="font-anton text-4xl md:text-5xl uppercase text-white leading-[0.95] mb-6">
              Áreas Atendidas
              <br />
              <span className="text-[#E50914]">24 Horas</span>
            </h2>
            <p className="font-work text-zinc-300 mb-6 leading-relaxed">
              Atendemos 24 horas por dia em Araçoiaba da Serra, Sorocaba, Votorantim, São Paulo e toda a região. Chegamos rápido onde você estiver — cidade, rodovia ou zona rural.
            </p>
            <a
              href={WHATSAPP_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="areas-cta-button"
              className="inline-flex items-center gap-2 bg-[#25D366] hover:bg-[#1EBE5D] text-white font-anton uppercase text-base md:text-lg tracking-wider px-6 py-3 transition-all hover:-translate-y-1 rounded-sm"
            >
              Sua cidade está na lista? Chama
            </a>

            {/* Embed map */}
            <div className="mt-8 border-2 border-zinc-800 hover:border-[#E50914] transition-colors">
              <iframe
                title="Localização Refúgio Guincho - Araçoiaba da Serra"
                src={`https://www.google.com/maps?q=${encodeURIComponent(BUSINESS.mapsQuery)}&output=embed`}
                width="100%"
                height="260"
                style={{ border: 0, display: "block", filter: "invert(0.9) hue-rotate(180deg)" }}
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                data-testid="areas-map"
              />
            </div>
          </div>

          <div className="lg:col-span-3">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
              {AREAS.map((area, i) => (
                <div
                  key={area}
                  data-testid={`area-item-${i}`}
                  className="group flex items-center gap-3 bg-[#171717] border border-zinc-800 hover:border-[#E50914] hover:bg-black p-4 transition-all"
                >
                  <div className="w-10 h-10 bg-[#E50914]/10 group-hover:bg-[#E50914] flex items-center justify-center transition-colors shrink-0">
                    <MapPin className="w-5 h-5 text-[#E50914] group-hover:text-white transition-colors" strokeWidth={2.5} />
                  </div>
                  <div>
                    <div className="font-anton text-lg md:text-xl text-white uppercase leading-none">{area}</div>
                    <div className="font-work text-xs text-zinc-500 uppercase tracking-wider mt-1">
                      Guincho 24h · Socorro
                    </div>
                  </div>
                </div>
              ))}
            </div>

            {/* SEO keyword block */}
            <div className="mt-6 p-5 md:p-6 bg-[#171717] border-l-4 border-[#E50914]">
              <p className="font-work text-sm md:text-base text-zinc-300 leading-relaxed">
                <strong className="text-white">Guincho em Araçoiaba da Serra</strong>,{" "}
                <strong className="text-white">guincho 24 horas Sorocaba</strong>,{" "}
                <strong className="text-white">socorro mecânico Votorantim</strong>,{" "}
                <strong className="text-white">reboque de carros Salto de Pirapora</strong>,{" "}
                <strong className="text-white">guincho para motos Iperó</strong>,{" "}
                <strong className="text-white">remoção de veículos Capela do Alto</strong>. Onde você estiver, a Refúgio Guincho chega.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
